import axios from "axios";

// Axios 요청 인터셉터
axios.interceptors.request.use(
  config => {
    let accessToken = localStorage.getItem("access_token");

    if (
      accessToken &&
      !config.headers.Authorization &&
      config.url.indexOf("code-AllList") === -1
    ) {
      config.headers.Authorization = accessToken;
    }

    return config;
  },
  error => Promise.reject(error)
);

// Axios 응답 인터셉터
axios.interceptors.response.use(
  response => response,
  error => {
    return Promise.reject(error);
  }
);

const requestDirectorObituary = () => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/director/reg-obituary-data`
  );
};

function requestEncode(parameter) {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/certify/encoding?str=${parameter}`
  );
}

export { requestDirectorObituary, requestEncode };
